import { render, staticRenderFns } from "./PanelNav.vue?vue&type=template&id=021d2184&scoped=true&"
import script from "./PanelNav.vue?vue&type=script&lang=js&"
export * from "./PanelNav.vue?vue&type=script&lang=js&"
import style0 from "./PanelNav.vue?vue&type=style&index=0&id=021d2184&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021d2184",
  null
  
)

export default component.exports